import { create } from "zustand";
import { axiosHelper, tokenHelper } from "../helpers";
import { filterNonFalseValues } from "../helpers/Utlis";

export const useSiteStore = create((set, get) => ({
  sites: [],
  siteList: [],
  listParams: { page: 1, perPage: 10, search: "" },
  isLoading: false,
  isError: false,
  error: undefined,
  filters: {
    code: "",
    DestProv: "",
    dateFrom: "",
    dateTo: "",
    access: "",
    driverId: "",
    charger: false,
  },
  createSiteFromOnboarding: async (body) => {
    set({ isLoading: true });
    try {
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.post("/site/create", body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      return response
    } catch (e) {
      console.log(e);

    } finally {
      set({ isLoading: false });
    }
  },
  // Methods
  createSite: async (body) => {
    set({ isLoading: true });

    try {
      // Get the access token
      const accessToken = await tokenHelper.getToken();

      // Post the site creation request
      const response = await axiosHelper.post("/site/create", body, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": undefined
        },
      });

      // Link the site to the user
      await axiosHelper.patch(
        `/user/link-site?siteId=${response.site_id}`,
        {},
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      // Refresh the full list (dropdowns) and the paginated table if it was loaded
      await get().getSites();
      await get().refreshSiteList();
      return response;
    } catch (e) {

      return null;
    } finally {
      set({ isLoading: false });
    }
  },
  getSiteList: async (page, perPage, search = "") => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      const params = new URLSearchParams({ page, perPage });
      if (search && search.trim() !== "") {
        params.append("search", search.trim());
      }
      let response = await axiosHelper.get(`/site/list?${params.toString()}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      set({
        siteList: response?.sites || [],
        pagination: response?.pagination,
        listParams: { page, perPage, search: search || "" },
        isLoading: false,
      });
      return response;
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },
  refreshSiteList: async () => {
    const { listParams, pagination } = get();
    if (!pagination) return;
    await get().getSiteList(
      listParams?.page || pagination.currentPage || 1,
      listParams?.perPage || pagination.perPage || 10,
      listParams?.search || ""
    );
  },
  getSites: async (filters) => {
    // set({ filters: filterNonFalseValues(filters) });
    // 
    // const filtering = {
    //   // search: filterNonFalseValues(filters) || "",
    //   ...filters,

    // };
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });

      let response = await axiosHelper.get("/user/sites", {
        headers: { Authorization: `Bearer ${accessToken}` },
      });


      const formattedResponse = response.map(site => ({
        ...site,
        logo: site.image_url
      }));

      set({ sites: formattedResponse, isLoading: false });
      return formattedResponse;
    } catch (e) {
      console.log(e);

    } finally {
      set({ isLoading: false });
    }
  },
  updateSite: async (id, info) => {
    try {

      const accessToken = await tokenHelper.getToken();

      set({ isLoading: true });
      let response = await axiosHelper.patch(`/site/${id}`, info, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": undefined
        },
      });


      await get().getSites();
      await get().refreshSiteList();
    } catch (e) {
      console.log(e);

    } finally {
      set({ isLoading: false });
    }
  },
  deleteSite: async (site_id) => {
    const accessToken = await tokenHelper.getToken();

    try {
      set({ isLoading: true });
      let response = await axiosHelper.delete(`/site/${site_id}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      await get().getSites();
      await get().refreshSiteList();
    } catch (e) {
      console.log(e);

    } finally {
      set({ isLoading: false });
    }
  },
  setFilters: (filters) => {
    set({ filters: filterNonFalseValues(filters) });
  },
  setSites: (sites) => set({ sites }),
}));
